import { Star } from "lucide-react";
import type { LorsCopy } from "./translations";

interface Testimonial {
  name: string;
  monthsAgo: number; // -1 means "a year ago"
  headline: { en: string; es: string };
  text: { en: string; es: string };
}

const testimonials: Testimonial[] = [
  {
    name: "Louise Gilbert",
    monthsAgo: 1,
    headline: {
      en: "Organized, Competent, and Kind",
      es: "Organizados, Competentes y Amables",
    },
    text: {
      en: "I am thrilled that I found Ruby Steinbrecher and her staff. They are very organized and competent and kind. When I was going through the process of establishing a Trust, they worked with me in answering all of my questions, which I am grateful for. They were very supportive throughout my process.",
      es: "Estoy encantada de haber encontrado a Ruby Steinbrecher y su equipo. Son muy organizados, competentes y amables. Cuando estaba pasando por el proceso de establecer un Fideicomiso, trabajaron conmigo respondiendo todas mis preguntas, por lo que estoy agradecida. Fueron muy solidarios durante todo mi proceso.",
    },
  },
  {
    name: "Carolyn Besse",
    monthsAgo: 2,
    headline: {
      en: "Attention to Detail Is Jaw-Dropping",
      es: "Su Atención al Detalle es Sorprendente",
    },
    text: {
      en: "I can't give enough praises for the Law Office of Ruby Steinbrecher. From the beginning, they were very attentive and professional. They were genuinely interested in my situation and gave all the time that was needed. Their experience and attention to detail is spot on and jaw dropping right down to the beautiful binder. I HIGHLY recommend the Law Office of Ruby Steinbrecher.",
      es: "No puedo elogiar lo suficiente a la Oficina Legal de Ruby Steinbrecher. Desde el principio, fueron muy atentos y profesionales. Estaban genuinamente interesados en mi situación y dieron todo el tiempo necesario. Su experiencia y atención al detalle es impecable y sorprendente, hasta la hermosa carpeta. Recomiendo ALTAMENTE la Oficina Legal de Ruby Steinbrecher.",
    },
  },
  {
    name: "Susan Daher",
    monthsAgo: 2,
    headline: {
      en: "I Felt Completely Safe and Cared For",
      es: "Me Sentí Completamente Segura y Cuidada",
    },
    text: {
      en: "Such a professional office, everyone is very caring and lets you know step-by-step what's going on. I felt completely safe and completely taken care of when we had some personal issues we needed to take care of. I would certainly recommend this office for any type of legal needs. I'm sold. She is the only office that I will ever go to for any legal matters — they are wonderful.",
      es: "Una oficina muy profesional, todos son muy atentos y te informan paso a paso lo que está sucediendo. Me sentí completamente segura y bien atendida cuando tuvimos algunos asuntos personales que resolver. Definitivamente recomendaría esta oficina para cualquier tipo de necesidad legal. Estoy convencida. Es la única oficina a la que iré para cualquier asunto legal — son maravillosos.",
    },
  },
  {
    name: "Kathleen Harrison",
    monthsAgo: 3,
    headline: {
      en: "The Free Workshop Was Eye-Opening",
      es: "El Taller Gratuito Me Abrió los Ojos",
    },
    text: {
      en: "I took Ruby's free, one-hour, introductory class. It was very helpful in describing options, common misunderstandings, and possible consequences. She gave reasons for cleaning up one's estate plan now, to protect descendants and to have an orderly plan in place. Ruby has a nice manner, and uses storytelling as a way to illustrate principles.",
      es: "Tomé la clase introductoria gratuita de una hora de Ruby. Fue muy útil para describir opciones, malentendidos comunes y posibles consecuencias. Dio razones para ordenar el plan patrimonial ahora, para proteger a los descendientes y tener un plan ordenado en su lugar. Ruby tiene una manera agradable y usa el arte de contar historias para ilustrar principios.",
    },
  },
  {
    name: "Jennie Bruneman",
    monthsAgo: 6,
    headline: {
      en: "They Made a Complicated Process Easy",
      es: "Hicieron Fácil un Proceso Complicado",
    },
    text: {
      en: "Ruby and her team are the best. They coached me through the entire trust planning process. My trust was a little tricky and they were on top of all the weird little nuances. The finished product was a beautiful binder detailing my entire trust. I feel so relieved to be protected and to have something in place for my daughter and loved ones. Thank you for making a complicated process seem so easy.",
      es: "Ruby y su equipo son los mejores. Me guiaron a través de todo el proceso de planificación del fideicomiso. Mi fideicomiso era un poco complicado y estaban al tanto de todos los pequeños matices. El producto terminado fue una hermosa carpeta detallando todo mi fideicomiso. Me siento tan aliviada de estar protegida y tener algo en su lugar para mi hija y seres queridos. Gracias por hacer que un proceso complicado pareciera tan fácil.",
    },
  },
  {
    name: "Jill Brown",
    monthsAgo: 3,
    headline: {
      en: "The Process Was Almost Enjoyable",
      es: "El Proceso Fue Casi Agradable",
    },
    text: {
      en: "I had a great experience with this law office when I had a new trust created. Ruby was wonderful and every single person I dealt with in the office was outstanding. They know all the legal ins and outs yet the process was almost enjoyable! Highly recommended.",
      es: "Tuve una gran experiencia con esta oficina legal cuando creé un nuevo fideicomiso. Ruby fue maravillosa y cada persona con la que traté en la oficina fue excepcional. Conocen todos los detalles legales y, sin embargo, ¡el proceso fue casi agradable! Altamente recomendada.",
    },
  },
  {
    name: "Bill Sorrell",
    monthsAgo: 6,
    headline: {
      en: "I Sleep Better Now That I Understand My Trust",
      es: "Duermo Mejor Ahora Que Entiendo Mi Fideicomiso",
    },
    text: {
      en: "Ruby Steinbrecher and everyone in the office are fantastic! They answered all my questions, offered solutions and provided so much peace of mind at a time I really needed it. They helped close out my wife's estate when she passed and now I have a trust that I understand. Ruby and the staff showed me how a law business can be smart, business-like, and professional while at the same time being kind, compassionate, and caring. I sleep better now that I know and understand my trust.",
      es: "¡Ruby Steinbrecher y todos en la oficina son fantásticos! Respondieron todas mis preguntas, ofrecieron soluciones y brindaron mucha tranquilidad en un momento en que realmente la necesitaba. Ayudaron a cerrar el patrimonio de mi esposa cuando falleció y ahora tengo un fideicomiso que entiendo. Ruby y el personal me mostraron cómo un negocio legal puede ser inteligente, profesional y al mismo tiempo amable, compasivo y atento. Duermo mejor ahora que conozco y entiendo mi fideicomiso.",
    },
  },
  {
    name: "Mollie Berg",
    monthsAgo: 7,
    headline: {
      en: "A Godsend for Tough, Sensitive Decisions",
      es: "Un Regalo del Cielo en Decisiones Difíciles",
    },
    text: {
      en: "Ruby Steinbrecher is a godsend to us. We knew the importance of handling our affairs and the daunting task we faced in making some very tough decisions. The burden we carried knowing our children would have to manage, unknowing our wishes, and the legalities of what we leave behind was just too heavy to carry. As we took action, Ruby and her staff made this process accessible, doable, and quite easy honestly. Their tenderness around these tough sensitive subjects made us feel absolutely comfortable, cared for and understood.",
      es: "Ruby Steinbrecher es un regalo del cielo para nosotros. Sabíamos la importancia de manejar nuestros asuntos y la tarea desalentadora que enfrentamos al tomar algunas decisiones muy difíciles. La carga que llevábamos sabiendo que nuestros hijos tendrían que manejar, sin conocer nuestros deseos, y las legalidades de lo que dejamos atrás era demasiado pesada. Al tomar acción, Ruby y su equipo hicieron este proceso accesible, factible y bastante fácil honestamente. Su ternura en torno a estos temas sensibles nos hizo sentir absolutamente cómodos, cuidados y comprendidos.",
    },
  },
  {
    name: "Robin Graefen",
    monthsAgo: -1,
    headline: {
      en: "Guided Us Step by Step",
      es: "Nos Guiaron Paso a Paso",
    },
    text: {
      en: "Ruby and her staff have been wonderful at guiding us through the process of creating a trust step by step! They answered all our questions and they were great at listening to our needs! I am so grateful to have our trust completed! We highly recommend the Law Office of Ruby Steinbrecher!",
      es: "¡Ruby y su equipo han sido maravillosos al guiarnos paso a paso por el proceso de crear un fideicomiso! ¡Respondieron todas nuestras preguntas y fueron excelentes escuchando nuestras necesidades! ¡Estoy muy agradecida de tener nuestro fideicomiso completado! ¡Recomendamos altamente la Oficina Legal de Ruby Steinbrecher!",
    },
  },
];

const Stars = () => (
  <div className="flex gap-0.5 mb-3">
    {[...Array(5)].map((_, i) => (
      <Star
        key={i}
        className="w-4 h-4"
        style={{ fill: "hsl(34 23% 60%)", color: "hsl(34 23% 60%)" }}
      />
    ))}
  </div>
);

const formatTime = (months: number, copy: LorsCopy) => {
  if (months === -1) return copy.timeAgo.yearAgo;
  if (months === 1) return copy.timeAgo.monthAgo;
  return copy.timeAgo.monthsAgo(months);
};

const LorsTestimonials = ({ copy, lang }: { copy: LorsCopy; lang: "en" | "es" }) => (
  <section className="py-20" style={{ backgroundColor: "hsl(199 21% 86% / 0.25)" }}>
    <div className="container max-w-6xl mx-auto px-6">
      <h2 className="lors-headline text-3xl md:text-4xl text-center mb-12">
        {copy.testimonialsTitle}
      </h2>
      <div className="columns-1 md:columns-2 lg:columns-3 gap-6 [column-fill:_balance]">
        {testimonials.map((t, i) => (
          <div
            key={i}
            className="break-inside-avoid mb-6 rounded-xl p-6 shadow-sm border"
            style={{
              backgroundColor: "hsl(0 0% 100%)",
              borderColor: "hsl(199 21% 86%)",
            }}
          >
            <Stars />
            <h3 className="lors-headline text-lg leading-snug mb-2">
              {t.headline[lang]}
            </h3>
            <p className="text-base leading-7 mb-4">{t.text[lang]}</p>
            <div>
              <p className="lors-subhead font-semibold text-sm">{t.name}</p>
              <p className="text-xs" style={{ color: "hsl(210 24% 35%)" }}>
                {formatTime(t.monthsAgo, copy)}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default LorsTestimonials;
